import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";

const connectedCapabilities = [
  { icon: "ri-radar-line", label: "Vehicle Monitoring" },
  { icon: "ri-charging-pile-line", label: "Charging Information" },
  { icon: "ri-bar-chart-box-line", label: "Usage Information" },
  { icon: "ri-tools-line", label: "Service Information" },
  { icon: "ri-roadster-line", label: "Fleet Visibility" },
  { icon: "ri-global-line", label: "Digital EV Ecosystem" },
];

const chargingFlow = [
  { icon: "ri-car-line", label: "Vehicle" },
  { icon: "ri-charging-pile-line", label: "Charging" },
  { icon: "ri-radar-line", label: "Monitoring" },
  { icon: "ri-tools-line", label: "Service" },
  { icon: "ri-route-line", label: "Mobility" },
];

export default function ConnectedChargingSection() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-container px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="Connected EV"
            title="A Retrofit That Connects to a Wider EV Ecosystem"
            description="Connectivity is approached as a set of possibilities across the ecosystem. We do not claim a specific feature is available for a given vehicle unless it is confirmed for that configuration."
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-6">
          {connectedCapabilities.map((item, index) => (
            <Reveal key={item.label} delay={index * 0.05}>
              <div className="flex h-full flex-col items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-5 text-center">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <span className="font-label text-xs font-semibold text-foreground-800">
                  {item.label}
                </span>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-16 rounded-lg border border-background-200 bg-background-50 p-6 md:p-10">
            <SectionHeading
              eyebrow="Charging Ecosystem"
              title="From the Vehicle to Charging, Monitoring, Service and Mobility"
              description="Retrofit connects the vehicle to charging. DJT contributes charging infrastructure and smart charging ecosystem technology to the collaboration."
            />
            <div className="mt-10 flex flex-wrap items-stretch justify-center gap-3">
              {chargingFlow.map((step, index) => (
                <div key={step.label} className="flex items-center gap-3">
                  <div className="flex w-28 flex-col items-center gap-3 rounded-lg border border-background-200 bg-background-100 px-4 py-5 md:w-32">
                    <span className="flex h-12 w-12 items-center justify-center rounded-md bg-foreground-950 text-primary-400">
                      <i className={`${step.icon} text-2xl`} />
                    </span>
                    <span className="font-label text-xs font-semibold text-foreground-800">
                      {step.label}
                    </span>
                  </div>
                  {index < chargingFlow.length - 1 ? (
                    <i className="ri-arrow-right-line hidden text-lg text-primary-500 md:block" />
                  ) : null}
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}